// NGRX
import { createAction, props } from '@ngrx/store';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { PatientImageChangeRequest } from '../_models/patient-image-change-request.model';

export const PatientsImageChangeRequestsPageRequested = createAction(
  '[Patients Image Change Requests Page] Patients Image Change Requests Page Requested',
  props<{ page: QueryParamsModel }>(),
);

export const DenyPatientImageChangeRequest = createAction(
  '[Patients Image Change Requests Page] Deny Patient Image Change Request',
  props<{ request: PatientImageChangeRequest; reason: string }>(),
);

export const ApprovePatientImageChangeRequest = createAction(
  '[Patients Image Change Requests Page] Approve Patient Image Change Request',
  props<{ request: PatientImageChangeRequest }>(),
);

export const PatientImageChangeRequestDenied = createAction(
  '[Patients Image Change Requests Page] Patient Image Change Request Denied',
  props<{ request: PatientImageChangeRequest; reason: string }>(),
);

export const PatientImageChangeRequestApproved = createAction(
  '[Patients Image Change Requests Page] Patient Image Change Request Approved',
  props<{ request: PatientImageChangeRequest }>(),
);

export const PatientsImageChangeRequestsPageLoaded = createAction(
  '[Patients API] Patients Image Change Requests Page Loaded',
  props<{ requests: PatientImageChangeRequest[]; totalCount: number; page: QueryParamsModel }>(),
);

export const PatientsImageChangeRequestPageCancelled = createAction(
  '[Patients Image Change Requests API] Patients Image Change Requests Page Cancelled',
);

export const PatientsImageChangeRequestPageToggleLoading = createAction(
  '[Patients Image Change Requests] Patients Image Change Requests Page Toggle Loading',
  props<{ isLoading: boolean }>(),
);

export const PatientImageChangeRequestActionToggleLoading = createAction(
  '[Patients Image Change Requests] Patients Image Change Requests Action Toggle Loading',
  props<{ isLoading: boolean }>(),
);

export const ThrowPatientImageChangeRequestError = createAction(
  '[Patients Image Change Requests] Throw Patient Image Change Requests Error',
  props<{ error: any }>(),
);

export const ClearPatienImageChangeRequesttErrors = createAction(
  '[Patients Image Change Requests] Clear Patient Image Change Requests Errors',
);

export const FirePatientImageChangeRequestSuccess = createAction(
  '[Patients Image Change Requests] Fire Success',
  props<{ action_type: string }>(),
);
